import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'name',
    label: 'Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'status',
    label: 'Status',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'description',
    label: 'Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'cancelationReason',
    label: 'Cancelation Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'submittedText',
    label: 'Submitted Text',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'slaFiles',
    label: 'SLA group task files',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'borrowerFiles',
    label: 'Borrower files',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isDocumentRequested',
    label: 'Ordered',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isDocumentRequested',
    label: 'Ordered',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'rejectionReason',
    label: 'Rejection Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const tasksInformationForm = {
  name: FormNames.TASK_INFORMATION,
  label: 'Task Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
